import EventBus from './EventBus'

export default class HandleScrollDown {
  constructor() {
    this.$el = document.querySelector('.scroll-down-wrapper')
    this.hidden = false
    this.timeout = null
    this.pageHeight = null
    EventBus.on('custom-scroll', (event) => {
      let scrollTop = event.detail.scrollTop
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      if (this.pageHeight === null) {
        this.pageHeight = document.body.offsetHeight - window.innerHeight
      }

      if (scrollTop >= this.pageHeight) {
        this.hide()
        return
      }

      this.hide()
      this.timeout = setTimeout(() => {
        this.show()
      }, 2000)
    })
  }

  hide() {
    if (this.hidden) {
      return
    }

    this.$el.classList.add('hide')
    this.hidden = true
  }

  show() {
    if (!this.hidden) {
      return
    }

    this.$el.classList.remove('hide')
    this.hidden = false
  }
}